<template>
  <div class="mydailyList">
    <div class="title_data">
      <div class="li">
        <span>{{ language("awaitDaily_editMyDaily.部门") }}:</span
        >{{ fromData.deptName }}
      </div>
      <div class="li">
        <span>{{ language("awaitDaily_editMyDaily.提交人") }}:</span
        >{{ fromData.userName }}
      </div>
      <div class="li li_time">
        <span>{{ language("awaitDaily_editMyDaily.日报日期") }}:</span>
        <div @click.stop="openTime">
          <el-input
            placeholder=""
            :value="dailyTime"
            size="mini"
            :disabled="view == 'view' || disabledTime"
          ></el-input>
        </div>
        <div class="calendar" v-show="showTime">
          <div class="table">
            <div class="table_button">
              <div>
                <h3>{{ seleteMonth }}</h3>
              </div>
              <div>
                <el-button size="mini" @click="changeDay('-')"
                  >上一月</el-button
                >
                <el-button size="mini" @click="changetoDay">今天</el-button>
                <el-button size="mini" @click="changeDay('+')"
                  >下一月</el-button
                >
              </div>
            </div>
            <div class="day_li_wrap">
              <div
                class="day_li"
                v-for="(data, index) in monthDay"
                @click="seleteDailyTime(data.day, dayList[data.day])"
                :class="dailyTime == data.day ? 'isToday day_li' : 'day_li'"
              >
                <template v-if="dayList[data.day] != 2">
                  <p :class="data.isToday ? 'isToday' : ''">
                    {{ data.day.split("-")[2] }}
                  </p>
                </template>
                <div class="icon_wrap">
                  <template v-if="dayList[data.day] == 0">
                    <i class="el-icon-close icon icon_close"></i>
                  </template>
                  <template v-if="dayList[data.day] == 1">
                    <i class="el-icon-check icon icon_check"></i>
                  </template>
                </div>

                <template v-if="dayList[data.day] == 2">
                  <div class="clsoe_day_wrap">
                    <p class="icon_check clsoe_day"></p>
                  </div>
                </template>
                <template v-if="dayList[data.day] == 3">
                  <p class="icon_check">可选</p>
                </template>
              </div>
            </div>
          </div>

          <div class="calendar_btn">
            <el-button @click.stop="cancelSeleteDailyTime">{{
              language("awaitDaily_editMyDaily.取消")
            }}</el-button>
            <el-button
              type="primary"
              v-if="dailyTime"
              @click.stop="confirmSeleteDailyTime"
              >{{ language("awaitDaily_editMyDaily.确定") }}</el-button
            >
          </div>
        </div>
      </div>
      <div class="li">
        <span>{{ language("awaitDaily_editMyDaily.状态") }}:</span
        ><el-tag size="mini" :type="status.tagType">{{ status.text }}</el-tag>
      </div>
    </div>

    <div class="card_wrap">
      <div class="title_wrap">
        <h4>{{ language("awaitDaily_editMyDaily.日报内容") }}</h4>
        <el-button
          type="primary"
          icon="el-icon-edit"
          size="mini"
          @click="openDialogDailyDetailsList"
          v-if="fromData.dailyDetailsList.length > 0 && view == 'edit'"
          >{{ language("awaitDaily_editMyDaily.添加内容") }}</el-button
        >
      </div>
      <div
        v-for="(item, index) in fromData.dailyDetailsList"
        v-if="fromData.dailyDetailsList.length > 0"
        style="margin-bottom: 20px"
      >
        <div class="card_box">
          <div class="selete_data">
            <div class="li_data li_data_2">
              <div class="left">
                <div class="title">
                  {{ language("awaitDaily_editMyDaily.内容") }}：
                </div>
                <div>
                  {{ getname(item) }}
                </div>
              </div>
              <div class="right">
                <div>
                  <el-link
                    type="primary"
                    icon="el-icon-edit"
                    v-if="view == 'edit' && item.isAudit != 1"
                    @click="openDialogDailyDetailsList(1, index)"
                    >{{ language("awaitDaily_editMyDaily.修改工序") }}</el-link
                  >
                </div>
                <el-link
                  type="primary"
                  icon="el-icon-delete"
                  v-if="view == 'edit' && item.isAudit != 1"
                  @click="deleteDailyDetailsList(index)"
                  >{{ language("awaitDaily_editMyDaily.删除工序") }}</el-link
                >
              </div>
            </div>
            <div
              class="li_data"
              v-for="(item2, index) in item.workshopDailyDetailsRelList"
            >
              <span
                >{{
                  item2.workshopChildProcess
                    ? item2.workshopChildProcess.name
                    : item2.name
                }}：</span
              >
              {{ item2.actualWorkingHours
              }}{{ language("awaitDaily_editMyDaily.小时") }}
            </div>
            <div class="li_data">
              <span>{{ language("awaitDaily_editMyDaily.实际工时") }}：</span>
              {{ item.actualWorkingHours }}
            </div>
            <!-- <div class="li_data">
            <span>{{ language("awaitDaily_editMyDaily.时间段") }}：</span>
            {{ item.startTime }} - {{ item.endTime }}
          </div> -->
          </div>
        </div>
        <div
          class="result"
          v-if="
            item.isAudit != 0 && item.isAudit != undefined && item.auditName
          "
        >
          <div>
            <div><h3>审核结果:</h3></div>
            <div>
              <span
                >{{ item.auditName }}：{{
                  item.auditOpinion ? item.auditOpinion + ";" : ""
                }}
                {{ getisAudit(item.isAudit) }};</span
              >
              <!-- <span>审核时间：{{ item.auditTime }}</span> -->
            </div>
          </div>
        </div>
      </div>
      <div class="card_box" v-if="fromData.dailyDetailsList.length == 0">
        <el-button
          type="primary"
          icon="el-icon-edit"
          v-if="view == 'edit'"
          @click="openDialogDailyDetailsList"
          >{{ language("awaitDaily_editMyDaily.添加内容") }}</el-button
        >
        <div v-if="view == 'view'">无内容</div>
      </div>

      <!-- <div class="result">
        <div><h3>审核结果:</h3></div>
        <div>
          <span>{{editData.auditUserName}}：{{editData.auditOpinion}}  {{getisAudit(editData.isAudit)}}</span>
          <span>审核时间：{{editData.auditTime}}</span>
        </div>
      </div> -->

      <div class="title_wrap somethingElseList">
        <h4>{{ language("awaitDaily_editMyDaily.其余事项") }}</h4>
      </div>
      <div class="card_box" v-if="fromData.somethingElseList.length > 0">
        <div class="selete_data">
          <div
            :class="
              'li_data ' +
              (fromData.somethingElseList.length - 1 > index ? 'li_data3' : '')
            "
            v-for="(itmes, index) in fromData.somethingElseList"
          >
            <div>
              <span>{{ itmes.name }}</span>
              <!-- <span
                >{{ itmes.value
                }}{{ language("awaitDaily_editMyDaily.小时") }}</span
              > -->
            </div>
            <div class="remark">
              <span>实际工时：</span>
              <span
                >{{ itmes.value
                }}{{ language("awaitDaily_editMyDaily.小时") }}</span
              >
            </div>
            <div class="remark" v-if="itmes.projectId">
              {{ language("awaitDaily_editMyDaily.项目") }}：{{
                itmes.projectName
              }}
              <!-- <el-select v-model="itmes.projectId" disabled>
                <el-option
                  v-for="item in itmes.projectArr"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                >
                </el-option>
              </el-select> -->
            </div>
            <div class="remark" v-if="itmes.unitId">
              {{ language("awaitDaily_editMyDaily.单元") }}：{{
                itmes.unitName
              }}
              <!-- <el-select v-model="itmes.unitId" disabled>
                <el-option
                  v-for="item in itmes.unitArr"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                >
                </el-option>
              </el-select> -->
            </div>
            <div class="remark" v-if="itmes.content">
              {{ language("awaitDaily_editMyDaily.内容") }}：{{ itmes.content }}
            </div>
            <div class="remark">
              <span>内容：</span>
              <div>{{ itmes.remark }}</div>
            </div>
          </div>
        </div>
        <div
          class="right2"
          v-if="view == 'edit' && fromData.dailyExtAudit != 1"
        >
          <div>
            <el-link
              type="primary"
              icon="el-icon-edit"
              @click="openDialogSomethingElseList(1)"
              >{{ language("awaitDaily_editMyDaily.修改事项") }}</el-link
            >
          </div>
          <el-link
            type="primary"
            icon="el-icon-delete"
            @click="deleteSomethingElseList(1)"
            >{{ language("awaitDaily_editMyDaily.删除事项") }}</el-link
          >
        </div>
      </div>

      <div class="card_box" v-if="fromData.somethingElseList.length == 0">
        <el-button
          type="primary"
          icon="el-icon-edit"
          v-if="view == 'edit'"
          @click="openDialogSomethingElseList"
          >{{ language("awaitDaily_editMyDaily.添加事项") }}</el-button
        >
        <div v-if="view == 'view'">无内容</div>
      </div>
      <div
        class="result"
        v-if="
          fromData.dailyExtAudit != 0 &&
          fromData.dailyExtAudit != undefined &&
          fromData.auditUserName
        "
      >
        <div><h3>审核结果:</h3></div>
        <div>
          <span
            >{{ fromData.auditUserName }}：{{
              fromData.dailyExtOpinion ? fromData.dailyExtOpinion + ";" : ""
            }}
            {{ getisAudit(editData.dailyExtAudit) }};</span
          >
          <!-- <span>审核时间：{{ editData.auditTime }}</span> -->
        </div>
      </div>
      <!-- <div class="result" v-if="editData.isAudit != 0">
        <div><h3>审核结果:</h3></div>
        <div>
          <span
            >{{ editData.auditUserName }}：{{
              editData.auditOpinion ? editData.auditOpinion + ";" : ""
            }}
            {{ getisAudit(editData.isAudit) }};</span
          >
          <span>审核时间：{{ editData.auditTime }}</span>
        </div>
      </div> -->
    </div>

    <div class="btn_wrap" style="margin-top: 20px">
      <el-button @click="closeAdd">{{
        language("awaitDaily_editMyDaily.取消")
      }}</el-button>
      <el-button type="primary" @click="sevaData" v-if="view == 'edit'">{{
        language("awaitDaily_editMyDaily.提交日报")
      }}</el-button>
    </div>
    <div class="tips">
      <span>** 注意：提交日报后无法补增加工序</span>
    </div>

    <!--日报内容添加-->
    <el-dialog
      :title="dialogDailyDetailsListTitle"
      :visible.sync="dialogDailyDetailsList"
      width="70%"
      append-to-body
      :close-on-click-modal="false"
    >
      <template v-if="dialogDailyDetailsList">
        <cc-form
          :config="formConfig"
          v-model="editObj"
          ref="editForm"
          :rules="rules"
        ></cc-form>
        <div class="button_wrap">
          <el-button size="mini" @click="close">{{
            $lange == "en" ? "Cancel" : "取消"
          }}</el-button>
          <el-button
            size="mini"
            type="primary"
            @click="editSubmitDailyDetails"
            >{{ $lange == "en" ? "Confirm" : "确认" }}</el-button
          >
        </div>
      </template>
    </el-dialog>

    <!--日报事項添加-->
    <el-dialog
      :title="dialogSomethingElseListTitle"
      :visible.sync="dialogSomethingElseList"
      width="90%"
      append-to-body
      :close-on-click-modal="false"
    >
      <template v-if="dialogSomethingElseList">
        <div v-for="(itme, index) in somethingElseObj">
          <div class="checkbox">
            <el-checkbox
              :label="itme.name"
              v-model="itme.checked"
            ></el-checkbox>

            <div class="">
              <div class="input_wrap">
                <div class="input">
                  <span><span style="color: red">*</span>实际工时</span>
                  <el-select
                    v-model="itme.value"
                    size="mini"
                    :disabled="!itme.checked"
                  >
                    <el-option
                      v-for="item in options"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    >
                    </el-option>
                  </el-select>
                </div>
                <div class="input">
                  <span>项目</span>
                  <el-select
                    v-model="itme.projectId"
                    size="mini"
                    :disabled="!itme.checked"
                    clearable
                    @change="changeProject($event, index)"
                    placeholder="请选择（非必填）"
                  >
                    <el-option
                      v-for="item in itme.projectArr"
                      :key="item.id"
                      :label="item.name"
                      :value="item.id"
                    >
                    </el-option>
                  </el-select>
                </div>
                <div class="input">
                  <span>单元</span>
                  <el-select
                    v-model="itme.unitId"
                    size="mini"
                    :disabled="!itme.checked"
                    clearable
                    @change="changeUnit($event, index)"
                     placeholder="请选择（非必填）"
                  >
                    <el-option
                      v-for="item in itme.unitArr"
                      :key="item.id"
                      :label="item.name"
                      :value="item.id"
                    >
                    </el-option>
                  </el-select>
                </div>
              </div>
              <div class="input">
                <span style="min-width: 71px;"><span style="color: red">*</span>内容</span>
                <el-input
                  :disabled="!itme.checked"
                  v-model="itme.remark"
                  type="textarea"
                  style="width: 100%"
                  placeholder="请输入内容"
                ></el-input>
              </div>
            </div>
          </div>
        </div>
        <div class="button_wrap">
          <el-button size="mini" @click="close">{{
            $lange == "en" ? "Cancel" : "取消"
          }}</el-button>
          <el-button
            size="mini"
            type="primary"
            @click="editSubmitSomethingElse"
            >{{ $lange == "en" ? "Submit" : "提交" }}</el-button
          >
        </div>
      </template>
    </el-dialog>
  </div>
</template>
<script>
import selectContent from "./items/selectContent.vue";
import selectEndTime from "./items/selectEndTime.vue";
import itemsContent from "./items.vue";
import moment from "moment";

let options = [];
let n = 0;
for (let i = 0; i < 48; i++) {
  n += 0.5;
  options.push({
    label: n,
    value: n,
  });
}

let startTimeOptions = [];
let items = ["00", "30"];
for (let index = 0; index < 24; index++) {
  let n = index < 10 ? "0" + index : index;
  for (let ind = 0; ind < items.length; ind++) {
    startTimeOptions.push({
      label: n + ":" + items[ind],
      value: n + ":" + items[ind],
    });
  }
}
startTimeOptions[16] = {
  label: "08:15",
  value: "08:15",
};
startTimeOptions[24] = {
  label: "11:50",
  value: "11:50",
};
startTimeOptions[26] = {
  label: "13:05",
  value: "13:05",
};

export default {
  props: {
    editData: Object,
    type: String,
  },
  data() {
    return {
      options: options,
      userData: {},
      showTime: false,
      formConfig: {
        props: [
          {
            name: "ids", //不可修改
            label: this.$lange == "en" ? "Content" : "阶段内容",
            request: true,
            componentName: selectContent,
            type: "component",
          },
          {
            name: "workshopDailyDetailsRelList", //不可修改
            label: this.language("workShop.详细工序"),
            request: true,
            componentName: itemsContent,
            type: "component",
          },

          // {
          //   name: "startTime",
          //   label: this.$lange == "en" ? "StartTime" : "开始时间",
          //   request: true,
          //   type: "select",
          //   options: startTimeOptions,
          // },
          // {
          //   name: "endTime",
          //   label: this.$lange == "en" ? "EndTime" : "结束时间",
          //   request: true,
          //   componentName: selectEndTime,
          //   type: "component",
          // },
          {
            name: "actualWorkingHours",
            label: this.$lange == "en" ? "Actual working hours" : "实际工时",
            request: true,
            disabled: true,
            type: "input",
          },
        ],
      },
      rules: {
        ids: [{ required: true, message: "请选择内容", trigger: "blur" }],
        // actualWorkingHours: [
        //   { required: true, message: "请输入实际工时", trigger: "blur" },
        // ],
        startTime: [
          { required: true, message: "请选择开始时间", trigger: "blur" },
        ],
        endTime: [
          { required: true, message: "请选择结束时间", trigger: "blur" },
          {
            validator: this.endTimeRules,
            trigger: "blur",
          },
        ],
        workshopDailyDetailsRelList: [
          { required: true, message: "请填写详细工序内容", trigger: "blur" },
          {
            validator: this.workshopDailyDetailsRelListeRules,
            trigger: "blur",
          },
        ],
      },
      dialogDailyDetailsListTitle: "添加",
      dialogDailyDetailsList: false,
      editObj: {
        startTime: "08:15",
        endTime: "当天17:30",
      },

      fromData: {
        dailyDetailsList: [],
        somethingElseList: [],
        deptName: "",
        userName: "",
        dailyTime: "",
      },

      editObjIndex: null,
      dialogSomethingElseList: false,
      dialogSomethingElseListTitle: "",
      somethingElseObj: [
        // {
        //   checked: "",
        //   value: "",
        //   name: "技术改造",
        // },
        // {
        //   checked: "",
        //   value: "",
        //   name: "质量问题返工",
        // },
        // {
        //   checked: "",
        //   value: "",
        //   name: "非工时日报",
        // },
        {
          checked: "",
          value: "",
          name: "技术改造",
          unitName: "",
          projectName: "",
          unitId: "",
          // content: "",
          projectId: "",
          projectArr: [],
          unitArr: [],
        },
        {
          checked: "",
          value: "",
          name: "质量问题返工",
          unitId: "",
          projectArr: [],
          unitArr: [],
          // content: "",
          unitName: "",
          projectName: "",
        },
        {
          checked: "",
          value: "",
          name: "非工时日报",
          unitId: "",
          projectArr: [],
          unitArr: [],
          // content: "",
          unitName: "",
          projectName: "",
        },
        {
          checked: "",
          value: "",
          remark: "",
          name: "其余事项",
          projectArr: [],
          unitArr: [],
          unitName: "",
          projectName: "",
        },
      ],
      editSomethingElseListIndex: null,

      dayList: {
        // "2021-09-01": 0,
        // "2021-09-02": 1,
        // "2021-09-03": 2,
        // "2021-09-04": 3,
      },
      monthDay: [],
      seleteMonth: this.$timeUtils.getYM(),

      dailyTime: "",

      view: "", // edit  view
      status: {},

      disabledTime: false,
    };
  },
  watch: {
    editObj: {
      handler() {
        let editObj = { ...this.editObj };
        if (editObj.startTime && editObj.endTime) {
          // var date1 = new Date("2300/01/01 " + editObj.startTime);
          // var date2 = new Date("2300/01/01 " + editObj.endTime.split("天")[1]);
          // if (editObj.endTime.length > 7) {
          //   date2 = new Date("2300/01/02 " + editObj.endTime.split("天")[1]);
          // }
          // var nDiff = date2 - date1;
          // var nHour, nMini, nSecond;
          // nHour = parseInt(nDiff / 3600000);
          // nMini = parseInt((nDiff % 3600000) / 60000);
          // this.editObj.actualWorkingHours = nHour + this.countnMini(nMini);
        }
      },
      deep: true,
      immediate: true,
    },
  },
  methods: {
    countnMini(n) {
      n = n / 10;
      if (n == 0) {
        return "";
      } else {
        let text = "";
        text = ((n / 30) * 5).toFixed(1);
        return text * 1;
      }
    },
    endTimeRules(rule, value, callback) {
      if (this.editObj.startTime) {
        if (value.length > 7) {
          callback();
        } else {
          let endTime = value.split("天")[1];
          let type = this.checkTime(this.editObj.startTime, endTime);
          if (type) {
            callback(new Error("开始时间不能大于结束时间"));
          } else {
            callback();
          }
        }
      }
    },
    workshopDailyDetailsRelListeRules(rule, value, callback) {
      if (value.length > 0) {
        // callback();
        let workshopDailyDetailsRelList = [];
        for (let index = 0; index < value.length; index++) {
          if (value[index].workshopChildProcess.actualWorkingHours > 0) {
            workshopDailyDetailsRelList.push(value[index]);
          }
        }
        if (workshopDailyDetailsRelList.length == 0) {
          callback(new Error("最少填一个工序"));
        } else {
          callback();
        }
      } else {
        callback(new Error("请填写详细工序内容"));
      }
    },
    checkTime(start, end) {
      console.log(start, end);
      let sTime = new Date(`2030/10/10 ${start}`).getTime();
      let eTime = new Date(`2030/10/10 ${end}`).getTime();
      let res = false;
      if (sTime > eTime) {
        res = true;
      }
      return res;
    },
    getisAudit(e) {
      if (e == 0) {
        return "待审核";
      } else if (e == 1) {
        return "审核通过";
      } else if (e == 2) {
        return "退回";
      }
    },
    changeDay(type) {
      if (type == "-") {
        this.seleteMonth = this.$timeUtils.topMonth(this.seleteMonth);
      } else {
        this.seleteMonth = this.$timeUtils.bottomMonth(this.seleteMonth);
      }
      this.getDay();
    },
    changetoDay() {
      this.seleteMonth = this.$timeUtils.getYM();
      this.getDay();
    },
    getDay(userId) {
      let list = this.$timeUtils.monthDay(this.seleteMonth);
      this.monthDay = list;
      console.log(list);
      this.ccRequest
        .do(
          "admin/fsb/workshop/daily/getOptionalDate",
          {
            userId: this.fromData.userId,
            yearMonth: this.seleteMonth,
          },
          "GET"
        )
        .then((res) => {
          this.dayList = { ...res };
          let arr = [];
          for (let index = 0; index < 7; index++) {
            if (
              res[this.$timeUtils.getNDay(-index)] == 3 &&
              !this.editData.id
            ) {
              this.fromData.dailyTime = this.$timeUtils.getNDay(-index);
              this.dailyTime = this.$timeUtils.getNDay(-index);
              break;
            }
          }
          console.log(arr);
        });
    },
    gatState(row) {
      if (this.editData.isAudit == 0) {
        if (this.editData.submitStatus == 1) {
          this.status = {
            tagType: "info",
            text: this.language("awaitDaily_dailyList.待审核"),
          };
        } else if (this.editData.submitStatus == 0) {
          this.status = {
            tagType: "danger",
            text: this.language("awaitDaily_dailyList.未提交"),
          };
        } else if (this.editData.submitStatus == 2) {
          this.status = {
            tagType: "danger",
            text: this.language("awaitDaily_dailyList.已关闭"),
          };
        }
      } else if (this.editData.isAudit == 1) {
        this.status = {
          tagType: "success",
          text: this.language("awaitDaily_dailyList.已审核"),
        };
      } else if (this.editData.isAudit == 2) {
        this.status = {
          tagType: "danger",
          text:
            this.language("awaitDaily_dailyList.未提交") +
            "(" +
            this.language("awaitDaily_dailyList.退回") +
            ")",
        };
      }
      // if (row.isAudit == 0) {
      //   if (row.submitStauts == 0) {
      //     return this.language("awaitDaily_dailyList.未提交");
      //   }
      //   return this.language("awaitDaily_dailyList.待审核");
      // } else if (row.isAudit == 1) {
      //   if (row.submitStauts == 2) {
      //     return this.language("awaitDaily_dailyList.已关闭");
      //   }
      //   return this.language("awaitDaily_dailyList.已审核");
      // } else if (row.isAudit == 2) {
      //   if (row.submitStauts == 0) {
      //     return this.language("awaitDaily_dailyList.未提交");
      //   }
      //   return this.language("awaitDaily_dailyList.退回");
      // }
    },
    openDialogDailyDetailsList(type, index) {
      if (type == 1) {
        // 編輯
        this.editObjIndex = index;
        this.editObj = JSON.parse(
          JSON.stringify(this.fromData.dailyDetailsList[this.editObjIndex])
        );
        this.editObj.actualWorkingHours = 0;
        this.editObj.workshopDailyDetailsRelList = [];

        console.log(this.editObj, this.fromData);
        this.dialogDailyDetailsListTitle = "編輯";
      } else {
        //新增
        this.editObj = {
          startTime: "08:15",
          endTime: "当天17:30",
          actualWorkingHours: "",
          workshopDailyDetailsRelList: [],
        };
        this.editObjIndex = null;
        this.dialogDailyDetailsListTitle = "添加";
      }
      this.dialogDailyDetailsList = true;
    },
    editSubmitDailyDetails() {
      console.log(this.editObj);
      this.$refs["editForm"]
        .validate()
        .then(() => {
          if (this.editObjIndex == null) {
            let type = false;
            for (
              let index = 0;
              index < this.fromData.dailyDetailsList.length;
              index++
            ) {
              if (
                this.fromData.dailyDetailsList[index].workshopProjectId ==
                this.editObj.ids.ids[0]
              ) {
                if (
                  this.fromData.dailyDetailsList[index].workshopUnitId ==
                  this.editObj.ids.ids[1]
                ) {
                  if (
                    this.fromData.dailyDetailsList[index].workshopOrderId ==
                    this.editObj.ids.ids[2]
                  ) {
                    if (
                      this.fromData.dailyDetailsList[index].workshopProcessId ==
                      this.editObj.ids.ids[3]
                    ) {
                      type = true;
                      break;
                    }
                  }
                }
              }
            }
            if (type) {
              this.$message.error("日报内容重复了");
              return false;
            }
          }
          let workshopDailyDetailsRelList = [];
          for (
            let index = 0;
            index < this.editObj.workshopDailyDetailsRelList.length;
            index++
          ) {
            if (
              this.editObj.workshopDailyDetailsRelList[index]
                .workshopChildProcess.actualWorkingHours > 0
            ) {
              workshopDailyDetailsRelList.push(
                this.editObj.workshopDailyDetailsRelList[index]
              );
            }
          }

          let editObj = {
            workshopProjectId: this.editObj.ids.ids[0],
            workshopUnitId: this.editObj.ids.ids[1],
            workshopOrderId: this.editObj.ids.ids[2],
            workshopProcessId: this.editObj.ids.ids[3],
            workshopDailyDetailsRelList: [],
            ids: this.editObj.ids,
            actualWorkingHours: this.editObj.actualWorkingHours,
          };
          for (
            let index = 0;
            index < workshopDailyDetailsRelList.length;
            index++
          ) {
            editObj.workshopDailyDetailsRelList.push({
              workshopProjectId: this.editObj.ids.ids[0],
              workshopUnitId: this.editObj.ids.ids[1],
              workshopOrderId: this.editObj.ids.ids[2],
              workshopProcessId: this.editObj.ids.ids[3],
              workshopChildProcessId:
                workshopDailyDetailsRelList[index].workshopChildProcess.id,
              workshopChildProcess:
                workshopDailyDetailsRelList[index].workshopChildProcess,
              actualWorkingHours:
                workshopDailyDetailsRelList[index].workshopChildProcess
                  .actualWorkingHours,
            });
          }

          if (this.editObjIndex == null) {
            this.fromData.dailyDetailsList.push(editObj);
          } else {
            this.fromData.dailyDetailsList[this.editObjIndex] = editObj;
          }
          this.dialogDailyDetailsList = false;
          console.log(this.fromData.dailyDetailsList);
        })
        .catch((er) => {
          console.log(er);
        });
    },
    deleteDailyDetailsList(index) {
      this.fromData.dailyDetailsList.splice(index, 1);
    },

    openDialogSomethingElseList(type) {
      if (type == 1) {
        console.log(this.somethingElseObj,this.fromData.somethingElseList);
        this.getProjectArr().then((projectArr) => {
          this.dialogSomethingElseList = true;
          this.dialogSomethingElseListTitle = "编辑";
          // if (this.fromData.somethingElseList.length < 2) {
          // this.somethingElseObj=this.fromData.somethingElseList
          for (
            let index = 0;
            index < this.fromData.somethingElseList.length;
            index++
          ) {
            for (let ind = 0; ind < this.somethingElseObj.length; ind++) {
              if (
                this.somethingElseObj[ind].name ==
                this.fromData.somethingElseList[index].name
              ) {
                this.somethingElseObj[ind].value =
                  this.fromData.somethingElseList[index].value;
                this.somethingElseObj[ind].checked =
                  this.fromData.somethingElseList[index].checked;

                this.somethingElseObj[ind].unitId =
                  this.fromData.somethingElseList[index].unitId || "";
                this.somethingElseObj[ind].projectId =
                  this.fromData.somethingElseList[index].projectId || "";
                this.somethingElseObj[ind].remark =
                  this.fromData.somethingElseList[index].remark || "";
                this.somethingElseObj[ind].projectArr = projectArr;
                // this.somethingElseObj[ind].content =
                //   this.fromData.somethingElseList[index].content || "";
              }
            }
          }
          for (let index = 0; index < this.somethingElseObj.length; index++) {
            //解決編輯沒有選擇問題
            this.somethingElseObj[index].projectArr = projectArr;
            //  //解決編輯沒有選擇問題
            if (this.somethingElseObj[index].projectId) {
              this.getUnitArr(this.somethingElseObj[index].projectId).then(
                (unit) => {
                  this.somethingElseObj[index].unitArr = unit;
                }
              );
            }
          }
          console.log(this.somethingElseObj,11111);
        });

        // }
      } else {
        this.getProjectArr().then((projectArr) => {
          this.dialogSomethingElseList = true;
          this.dialogSomethingElseListTitle = "新增";
          this.somethingElseObj = [
            {
              checked: "",
              value: "",
              name: "技术改造",
              unitName: "",
              projectName: "",
              unitId: "",
              // content: "",
              projectId: "",
              projectArr: [...projectArr],
              remark: "",
              unitArr: [],
            },
            {
              checked: "",
              value: "",
              name: "质量问题返工",
              unitId: "",
              projectArr: [...projectArr],
              unitArr: [],
              // content: "",
              unitName: "",
              remark: "",
              projectName: "",
            },
            {
              checked: "",
              value: "",
              name: "非工时日报",
              unitId: "",
              projectArr: [...projectArr],
              unitArr: [],
              // content: "",
              unitName: "",
              remark: "",
              projectName: "",
            },
            {
              checked: "",
              value: "",
              remark: "",
              name: "其余事项",
              projectArr: [...projectArr],
              unitArr: [],
              unitName: "",
              projectName: "",
            },
          ];
        });
      }
    },

    editSubmitSomethingElse() {
      let type = false;
      let text = "";
      let somethingElseList = [];
      let somethingElseObj = [...this.somethingElseObj];
      //判断有没有勾选和填入工时
      for (let index = 0; index < somethingElseObj.length; index++) {
        if (somethingElseObj[index].checked) {
          if (somethingElseObj[index].value == "") {
            text = "请填入" + somethingElseObj[index].name + "工时";
            type = true;
            break;
          }

          if (somethingElseObj[index].projectId) {
            if (!somethingElseObj[index].unitId) {
              text = "请选择" + somethingElseObj[index].name + "单元";
              type = true;
              break;
            }
          }

          if (somethingElseObj[index].unitId) {
            if (!somethingElseObj[index].projectId) {
              text = "请选择" + somethingElseObj[index].name + "项目";
              type = true;
              break;
            }
          }

          // if (somethingElseObj[index].content == "") {
          //   text = "请填入" + somethingElseObj[index].name + "内容";
          //   type = true;
          //   break;
          // }

          // if (somethingElseObj[index].name == "其余事项") {
          if (somethingElseObj[index].remark == "") {
            text = "请填入" + somethingElseObj[index].name + "内容";
            type = true;
            break;
          }
          // }

          somethingElseList.push(somethingElseObj[index]);
        }
      }
      if (type) {
        this.$message.error(text);
        return false;
      }
      if (somethingElseList.length == 0) {
        this.$message.error("请勾选事项并填写内容");
        return false;
      }
      this.fromData.somethingElseList = JSON.parse(
        JSON.stringify(somethingElseList)
      );
      this.dialogSomethingElseList = false;
    },
    deleteSomethingElseList(index) {
      this.fromData.somethingElseList = [];
    },

    close() {
      this.dialogDailyDetailsList = false;
      this.dialogSomethingElseList = false;
    },
    openTime() {
      if (this.view == "view" || this.disabledTime) {
        return false;
      }
      this.showTime = true;
      this.dailyTime = this.fromData.dailyTime;
    },
    seleteDailyTime(e, state) {
      if (state != 3) {
        this.$message.error("不可选");
        return false;
      }
      console.log(e);
      this.dailyTime = e;
    },
    confirmSeleteDailyTime() {
      this.fromData.dailyTime = this.dailyTime;
      this.showTime = false;
    },
    cancelSeleteDailyTime() {
      this.dailyTime = this.fromData.dailyTime;
      this.showTime = false;
    },
    sevaData() {
      if (this.fromData.dailyTime == "") {
        this.$message.error("请选择日报时间");
        return false;
      }
      if (
        this.fromData.dailyDetailsList.length == 0 &&
        this.fromData.somethingElseList.length == 0
      ) {
        this.$message.error("请填写日报内容或其余事项");
        return false;
      }
      let allTime = 0;
      let fromData = {
        dailyDetailsList: [...this.fromData.dailyDetailsList],
        somethingElseList: [...this.fromData.somethingElseList],
        workshopDaily: {
          userId: this.fromData.userId,
          deptId: this.fromData.deptId,
          dailyTime: this.fromData.dailyTime,
        },
      };

      for (
        let index = 0;
        index < this.fromData.dailyDetailsList.length;
        index++
      ) {
        allTime +=
          this.fromData.dailyDetailsList[index].actualWorkingHours * 1000;
        if (!this.fromData.dailyDetailsList[index].workshopOrderId) {
          this.fromData.dailyDetailsList[index].workshopOrderId =
            this.fromData.dailyDetailsList[
              index
            ].workshopDailyDetailsRelList[0].workshopOrderId;
          this.fromData.dailyDetailsList[index].workshopProcessId =
            this.fromData.dailyDetailsList[
              index
            ].workshopDailyDetailsRelList[0].workshopProcessId;
          this.fromData.dailyDetailsList[index].workshopProjectId =
            this.fromData.dailyDetailsList[
              index
            ].workshopDailyDetailsRelList[0].workshopProjectId;
          this.fromData.dailyDetailsList[index].workshopUnitId =
            this.fromData.dailyDetailsList[
              index
            ].workshopDailyDetailsRelList[0].workshopUnitId;
        }
      }
      for (let index = 0; index < fromData.somethingElseList.length; index++) {
        allTime += fromData.somethingElseList[index].value * 1000;
      }

      if (this.editData.id) {
        fromData.isAudit = this.editData.isAudit;
        fromData.id = this.editData.id;
        if (this.fromData.somethingElseList.length > 0) {
          if (this.editData.dailyExtAudit != undefined) {
            fromData.dailyExtAudit = this.editData.dailyExtAudit;
          }
        }
      }

      console.log(fromData, allTime, this.fromData);

      //1000 以防+出现精度丢失
      if (allTime > 8000 || allTime < 8000) {
        this.$confirm(
          "日报工时" + (allTime > 8000 ? "大于" : "小于") + "8小时,是否继续?",
          "提示",
          {
            confirmButtonText: "继续提交",
            cancelButtonText: "取消提交",
            type: "warning",
          }
        )
          .then(() => {
            this.submitDaily(fromData);
          })
          .catch(() => {});
      } else {
        this.submitDaily(fromData);
      }
    },
    submitDaily(fromData) {
      let data = JSON.parse(JSON.stringify(fromData));
      for (let index = 0; index < data.somethingElseList.length; index++) {
        delete data.somethingElseList[index].projectArr;
        delete data.somethingElseList[index].unitArr;
      }
      console.log(data);
      // return false;
      this.ccRequest
        .do("admin/fsb/workshop/daily/submitDaily", data, "POSTJSON")
        .then((res) => {
          this.$message.success(this.language("awaitDaily_dailyList.操作成功"));
          this.$emit("updateData", true);
        })
        .catch((err) => {
          this.$message.error(err.response.data.message);
        });
    },
    closeAdd() {
      this.$emit("close", true);
    },
    getname(item) {
      console.log(item, "item");
      if (item.content) {
        return item.content;
      } else {
        let name = item.ids.name[item.ids.name.length - 1];
        if (name == "") {
          return item.ids.name.splice("-");
        } else {
          return name;
        }
      }
    },
    getProjectArr() {
      return new Promise((resolve, reject) => {
        this.ccRequest
          .do("admin/fsb/workshop/project/query", { pageSize: 100000 }, "GET")
          .then((res) => {
            resolve(res.rows);
          })
          .catch((err) => {
            reject();
            this.$message.error(err.response.data.message);
          });
      });
    },
    getUnitArr(workshopProjectId) {
      return new Promise((resolve, reject) => {
        this.ccRequest
          .do(
            "admin/fsb/workshop/unit/query",
            { pageSize: 100000, workshopProjectId: workshopProjectId },
            "GET"
          )
          .then((res) => {
            resolve(res.rows);
          })
          .catch((err) => {
            reject();
            this.$message.error(err.response.data.message);
          });
      });
    },
    changeProject($event, index) {
      if ($event == "") {
        this.somethingElseObj[index].unitArr = [];
        this.somethingElseObj[index].unitId = "";
        this.somethingElseObj[index].unitName = "";
        return false;
      }
      this.getUnitArr($event).then((unit) => {
        for (
          let t = 0;
          t < this.somethingElseObj[index].projectArr.length;
          t++
        ) {
          if (this.somethingElseObj[index].projectArr[t].id == $event) {
            this.somethingElseObj[index].projectName =
              this.somethingElseObj[index].projectArr[t].name;
          }
        }
        this.somethingElseObj[index].unitArr = unit;
        this.somethingElseObj[index].unitId = "";
        this.somethingElseObj[index].unitName = "";
      });
    },
    changeUnit($event, index) {
      console.log($event, index);
      for (let t = 0; t < this.somethingElseObj[index].unitArr.length; t++) {
        if (this.somethingElseObj[index].unitArr[t].id == $event) {
          this.somethingElseObj[index].unitName =
            this.somethingElseObj[index].unitArr[t].name;
        }
      }
    },
  },
  mounted() {
    this.gatState();
    this.view = this.type;
    if (!this.editData.id) {
      ////构建其他字段
      this.ccRequest.do("validate", {}, "GET").then((res) => {
        this.userData = res;
        this.fromData.deptName = res.deptName;
        this.fromData.userName = res.name;
        this.fromData.userId = res.id;
        this.fromData.deptId = res.deptId;
        this.fromData.isAudit = 0;
        this.fromData.submitStauts = 0;
        this.getDay(this.fromData.userId);
        if (this.editData.dailyTime) {
          this.disabledTime = true;
        }
      });
    } else {
      this.disabledTime = true;
      // this.getDay(this.editData.userId);
      //构建其他字段
      this.fromData.deptName = this.editData.deptName;
      this.fromData.userName = this.editData.userName;
      this.fromData.userId = this.editData.userId;
      this.fromData.deptId = this.editData.deptId;
      this.fromData.isAudit = this.editData.isAudit;
      this.fromData.auditUserId = this.editData.auditUserId;
      this.fromData.dailyExtAudit = this.editData.dailyExtAudit;
      this.fromData.dailyExtOpinion = this.editData.dailyExtOpinion;
      this.fromData.auditUserName = this.editData.auditUserName;
      this.fromData.submitStauts = this.editData.submitStauts;
      this.fromData.dailyTime = moment(this.editData.dailyTime).format(
        "YYYY-MM-DD"
      );
      this.dailyTime = moment(this.editData.dailyTime).format("YYYY-MM-DD");

      //构建事项
      for (
        let index = 0;
        index < this.editData.somethingElseList.length;
        index++
      ) {
        this.editData.somethingElseList[index].checked = true;
      }
      this.fromData.somethingElseList = [...this.editData.somethingElseList];

      //构建内容
      let workshopDailyDetailsList = this.editData.workshopDailyDetailsList;
      let dailyDetailsList = [];
      for (let index = 0; index < workshopDailyDetailsList.length; index++) {
        let ids = [];
        let name = [];
        ids.push(workshopDailyDetailsList[index].workshopProjectId);
        name.push(workshopDailyDetailsList[index].workshopProject.name);

        ids.push(workshopDailyDetailsList[index].workshopUnitId);
        name.push(workshopDailyDetailsList[index].workshopUnit.name);

        ids.push(workshopDailyDetailsList[index].workshopOrderId);
        name.push(workshopDailyDetailsList[index].workshopOrder.numbering);

        ids.push(workshopDailyDetailsList[index].workshopProcessId);
        name.push(workshopDailyDetailsList[index].workshopProcess.content);

        let endTime = workshopDailyDetailsList[index].endTime;
        if (workshopDailyDetailsList[index].endTime.length == 5) {
          endTime = "当天" + endTime;
        }
        dailyDetailsList.push({
          actualWorkingHours:
            workshopDailyDetailsList[index].actualWorkingHours,
          endTime: endTime,
          startTime: workshopDailyDetailsList[index].startTime,
          ids: {
            ids: ids,
            name: name,
          },
          content: workshopDailyDetailsList[index].content,
          isAudit: workshopDailyDetailsList[index].isAudit,
          auditName: workshopDailyDetailsList[index].auditName,
          auditOpinion: workshopDailyDetailsList[index].auditOpinion,
          workshopDailyDetailsRelList:
            workshopDailyDetailsList[index].workshopDailyDetailsRelList,
        });
        console.log(
          workshopDailyDetailsList[index].workshopDailyDetailsRelList,
          " workshopDailyDetailsList[index].workshopDailyDetailsRelList,"
        );
      }
      this.fromData.dailyDetailsList = [...dailyDetailsList];
      // console.log(this.fromData.dailyDetailsList);
    }
    console.log(this.editData, this.fromData);
  },
};
</script>
<style scoped lang="scss">
.title_data {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  .li {
    margin: 10px 0;
    width: 200px;
    font-weight: 700;
    display: flex;
    align-items: center;
    span {
      margin-right: 10px;
    }
  }
  .li_time {
    width: 300px;
    position: relative;
    span {
      width: 80px;
    }
    .calendar {
      position: absolute;
      // bottom: -730px;
      bottom: -652px;
      left: -50%;
      width: 600px;
      border: 1px solid #eaeefb;
      z-index: 3;
      .icon_wrap {
        width: 100%;
        display: flex;
        justify-content: center;
      }
      .icon {
        font-size: 20px;
      }
      .icon_check {
        color: #1ab394;
      }
      .clsoe_day_wrap {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
      }
      .clsoe_day {
        color: red;
        background: #eaeefb;
      }
      .icon_close {
        color: #d6001a;
      }
    }
    .calendar_btn {
      background: #fff;
      padding: 0 0 20px 20px;
    }
    .table_button {
      display: flex;
      justify-content: space-between;
      margin-bottom: 20px;
    }
    .day_li_wrap {
      display: flex;
      flex-wrap: wrap;
      border-left: 1px solid #ebeef5;
      border-top: 1px solid #ebeef5;
      height: 490px;
    }
    .day_li {
      position: relative;
      cursor: pointer;
      width: 12.7%;
      height: 60px;
      padding: 10px;
      border-bottom: 1px solid #ebeef5;
      border-right: 1px solid #ebeef5;
    }
    .day_li:hover {
      background: #f2f8fe;
      color: #000;
    }
    .clsoe_day:hover {
      background: #ebeef5;
      color: #000;
    }
    .isToday {
      background: #1ab394 !important;
      color: #fff;
    }
    p {
      border-radius: 30px;
      width: 30px;
      height: 30px;
      display: flex;
      align-items: center;
      justify-content: center;
      margin: 0 auto;
    }
    .isToday .icon_check {
      color: #fff !important;
    }
    .isToday:hover p {
      color: #fff !important;
    }
    // .day_li:hover .icon_check {
    //   color: #000;
    // }
  }
}
.card_wrap {
  .title_wrap {
    display: flex;
    align-items: center;
    h4 {
      padding: 10px 20px 10px 0;
    }
  }
  .card_box {
    // margin-bottom: 20px;
    // margin-bottom: 10px;
    min-height: 120px;
    background-color: rgb(245, 247, 250);
    border-color: rgb(220, 224, 235);
    border-width: 1px;
    border-style: solid;
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
    .right2 {
      position: absolute;
      right: 0px;
      top: 20px;
      width: 100px;
      div {
        margin-bottom: 20px;
      }
    }
    .right {
      position: absolute;
      right: 0px;
      top: 20px;
      width: 100px;
      div {
        margin-bottom: 20px;
      }
    }
  }
  .selete_data {
    font-size: 14px;
    font-weight: 700;
    width: 100%;
    min-height: 120px;
    padding: 20px;
    box-sizing: border-box;
    position: relative;
    .li_data {
      margin-bottom: 10px;
      // padding-bottom: 20px;
      // margin-bottom: 20px;
      // border-bottom: 1px solid #dce0eb;
    }

    .li_data_2 {
      display: flex;
      justify-content: space-between;
      .left {
        display: flex;
        align-items: center;
        width: 80%;
        .title {
          min-width: 50px;
        }
      }
    }
    .li_data3 {
      padding-bottom: 20px !important;
      margin-bottom: 20px !important;
      border-bottom: 1px solid #dce0eb !important;
    }
  }
}

.btn_wrap {
  display: flex;
  justify-content: center;
}
.button_wrap {
  display: flex;
  justify-content: center;
}

.checkbox {
  display: flex;
  // align-items: center;

  flex-wrap: wrap;
}
.checkbox .input {
  margin-bottom: 20px;
  margin-left: 20px;
  display: flex;
  // align-items: center;
  span {
    margin-right: 10px;
  }
}
.remark {
  margin-top: 10px;
  display: flex;
  div {
    white-space: pre;
  }
}

.result {
  // margin-bottom: 20px;
  border: 1px solid #dce0eb;
  border-top: none;
  padding: 10px 20px;
  background: #f5f7fa;
  span {
    color: #1ab394;
    margin-right: 10px;
  }
  h3 {
    margin-bottom: 5px;
  }
}
.table {
  background: #fff;
  padding: 20px;
}
.tips {
  margin-top: 20px;
  color: #f56c6c;
  display: flex;
  justify-content: center;
}
</style>
<style >
.mydailyList .el-calendar-table .el-calendar-day {
  padding: 0 !important;
}
.mydailyList .day_list {
  height: 100%;
  padding: 8px;
}
.el-checkbox__label {
  width: 100px !important;
}
.input_wrap {
  /* width: 89%; */
  display: flex;
  flex-wrap: wrap;
}
</style>